import { Errors } from 'config'

const IDENTITY_TOOLKIT_URL = 'https://identitytoolkit.googleapis.com/v1'

// API error codes the Firebase SDK reports under different names
const API_ERROR_CODES: Partial<Record<string, Errors>> = {
  INVALID_OOB_CODE: Errors.InvalidActionCode,
  EXPIRED_OOB_CODE: Errors.ExpiredActionCode,
}

export interface ActionCodeDetails {
  requestType?: string
  email?: string
  mfaInfo?: { displayName?: string }
}

const toAuthErrorCode = (apiErrorMessage = '') => {
  const [apiErrorCode] = apiErrorMessage.split(' : ')
  return (
    API_ERROR_CODES[apiErrorCode] ??
    `auth/${apiErrorCode.toLowerCase().replace(/[_\s]+/g, '-')}`
  )
}

// The same request as checkActionCode of the SDK, which fails with an internal
// error when a field it expects is missing and so hides why a link can't be used
export const lookUpActionCode = async (
  apiKey: string,
  oobCode: string,
  appCheckToken?: string
): Promise<ActionCodeDetails> => {
  let response: Response
  let body: any
  try {
    response = await fetch(
      `${IDENTITY_TOOLKIT_URL}/accounts:resetPassword?key=${apiKey}`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(appCheckToken && { 'X-Firebase-AppCheck': appCheckToken }),
        },
        body: JSON.stringify({ oobCode }),
      }
    )
    body = await response.json()
  } catch {
    // eslint-disable-next-line no-throw-literal
    throw { code: Errors.NetworkRequestFailed }
  }

  if (!response.ok) {
    // eslint-disable-next-line no-throw-literal
    throw { code: toAuthErrorCode(body?.error?.message) }
  }
  return body
}
